import { TAGS_DIALOG_SELECT_TAB } from '../../../lib/constants';
import getMultiLevelTags from '../../../actions/api/tag/getMultiLevelTags';

/**
 * タグ編集ダイアログの更新ボタンが無効化されているかどうかを判定する関数
 *
 * @param {string} selectedTab 選択中のタブ
 * @param {string} freeTag 編集中の自由タグ
 * @param {object} ids 編集中の階層タグのID
 * @param {object} clearCheckbox 削除対象を表すチェックボックスのオブジェクト
 * @returns {boolean} タグ更新ボタンが無効化されている場合はtrue、それ以外はfalse
 */
export const isTagUpdateButtonDisabled = (
  selectedTab,
  freeTag,
  ids,
  clearCheckbox,
) => {
  const isUpdateTabSelected = selectedTab === TAGS_DIALOG_SELECT_TAB.update;
  const isClearTabSelected = selectedTab === TAGS_DIALOG_SELECT_TAB.clear;

  const isUpdateConditionMet = Object.keys(ids).length > 0 || !!freeTag;
  const isClearConditionMet = clearCheckbox.masterTag || clearCheckbox.freeTag;

  return (
    (isUpdateTabSelected && !isUpdateConditionMet) ||
    (isClearTabSelected && !isClearConditionMet)
  );
};

/**
 * 階層タグ選択ボックスの値が変更された時に呼び出される関数
 *
 * @param {*} e - イベントオブジェクト
 * @param {*} dispatch - reduxのdispatch関数
 * @param {*} depth - 選択している階層タグの階層
 * @param {*} ids - 階層タグの選択肢のID
 * @param {*} apiToken - 認証用のAPIトークン
 * @param {*} targetGroupId - 現在選択しているグループのID
 */
export const handleTagChange = (
  e,
  dispatch,
  depth,
  ids,
  apiToken,
  targetGroupId,
) => {
  dispatch({
    type: 'UPDATE_TAG_ID',
    depth,
    id: Number(e.target.value),
  });

  const searchIds = Object.keys(ids)
    .filter(key => key < depth)
    .map(key => ids[key]);
  searchIds[depth - 1] = Number(e.target.value);

  dispatch(
    getMultiLevelTags(
      apiToken,
      {
        parentIds: searchIds,
        isUsable: true,
        actionType: 'UPDATE_EDIT_TAGS',
      },
      targetGroupId,
    ),
  );
};
